<div class="job-search-container" style="position: relative">
  @if (!isMultiSelect) {
    <kendo-dropdownlist
      #jobDropdown
      class="k-no-dropdown w-100"
      [value]="selectedJob"
      [valuePrimitive]="false"
      [textField]="'Name'"
      [valueField]="'JobID'"
      [filterable]="true"
      [disabled]="disabled"
      (valueChange)="valueChangeJob($event)"
      [defaultItem]="{ Name: placeholder }"
      search-ex
      [seSearchColumns]="['VpJobId', 'Name']"
      (seFilterChangeEx)="filterDebounce.next($event)"
      [seDebounceFilterChange]="150"
      [seUseCustomLocalFilter]="true"
      [seMinSearchLength]="0"
      help-anchor="dropdown-list__job"
    >
      <ng-template kendoDropDownListItemTemplate let-dataItem>
        <div style="display: inline-flex">
          @if (
            dataItem.JobID &&
            showFavoritesButton &&
            !dataItem.IsTemporaryForemanJob
          ) {
            <span (click)="toggleFavorite(dataItem, $event)">
              <i
                class="fas fa-star"
                title="Add/Remove Favorite Job"
                [ngStyle]="{
                  color: dataItem.IsUserFavorite ? 'orange' : 'lightgrey',
                }"
              ></i>
              &nbsp;
            </span>
          }
          @if (
            dataItem.JobID &&
            showFacilityTooltip &&
            !dataItem.IsTemporaryForemanJob
          ) {
            <span kendoTooltip [tooltipTemplate]="facilityTooltip">
              <i class="fa fa-info-circle" title></i>
              &nbsp;
            </span>
          }

          <ng-template #facilityTooltip>
            <div>Active Jobs:</div>
            @if (dataItem.FacilityActiveJobs.length === 0) {
              <div>N/A</div>
            }
            @for (job of dataItem.FacilityActiveJobs; track job) {
              <div>{{ job }}</div>
            }
          </ng-template>
          @if (dataItem.IsDispatched) {
            <span>
              <i
                class="fas fa-walking"
                title="{{
                  hrRef ? 'Employee is dispatched on this job' : 'Dispatched'
                }}"
              ></i>
              &nbsp;
            </span>
          }
          <div>
            @if (dataItem.JobID) {
              <strong>
                {{ dataItem.JobID }}
              </strong>
              <span>{{ ' - ' }}</span>
            }
            @if (dataItem.Name) {
              <span class="job-name">
                {{ dataItem.Name }}
              </span>
            }
            @if (!dataItem.IsActive && dataItem.JobID) {
              <span class="text-danger">(Closed)</span>
            }
          </div>
        </div>
      </ng-template>
      <ng-template kendoDropDownListValueTemplate let-dataItem>
        @if (
          dataItem.JobID &&
          showFavoritesButton &&
          !dataItem.IsTemporaryForemanJob
        ) {
          <span (click)="toggleFavorite(dataItem, $event)">
            <i
              class="fas fa-star"
              title="Add/Remove Favorite Job"
              [ngStyle]="{
                color: dataItem.IsUserFavorite ? 'orange' : 'lightgrey',
              }"
            ></i>
            &nbsp;
          </span>
        }
        @if (
          dataItem.JobID &&
          showFacilityTooltip &&
          !dataItem.IsTemporaryForemanJob
        ) {
          <span kendoTooltip [tooltipTemplate]="facilityTooltip">
            <i class="fa fa-info-circle" title></i>
            &nbsp;
          </span>
        }

        <ng-template #facilityTooltip>
          <div>Active Jobs:</div>
          @if (dataItem.FacilityActiveJobs.length === 0) {
            <div>N/A</div>
          }
          @for (job of dataItem.FacilityActiveJobs; track job) {
            <div>{{ job }}</div>
          }
        </ng-template>
        @if (dataItem.IsDispatched) {
          <span>
            <i
              class="fas fa-walking"
              title="{{
                hrRef ? 'Employee is dispatched on this job' : 'Dispatched'
              }}"
            ></i>
            &nbsp;
          </span>
        }

        <span
          kendoTooltip
          [title]="
            dataItem.JobID +
            ' - ' +
            dataItem.Name +
            (!dataItem.IsActive && dataItem.JobID ? ' (Closed)' : '')
          "
        >
          @if (dataItem.JobID) {
            <strong>
              {{ dataItem.JobID }}
            </strong>
            <span>{{ ' - ' }}</span>
          }
          @if (dataItem.Name) {
            <span class="job-name">
              {{ dataItem.Name }}
            </span>
          }
          @if (!dataItem.IsActive && dataItem.JobID) {
            <span class="text-danger">(Closed)</span>
          }
        </span>
      </ng-template>
      <ng-template kendoDropDownListFooterTemplate>
        @if (resultsCapped()) {
          <div class="job-search-capped">
            Showing the first {{ dropdownTake }} matching jobs. More may match:
            keep typing the job number or name to narrow the list.
          </div>
        }
      </ng-template>
    </kendo-dropdownlist>
  }
  @if (isMultiSelect) {
    <kendo-multiselect
      #jobDropdown
      class="k-no-dropdown w-100"
      [ngStyle]="{ width: showClosedJobsCheckbox ? '88%' : '100%' }"
      [value]="selectedJobs"
      help-anchor="job"
      [valuePrimitive]="false"
      [textField]="'JobID'"
      [valueField]="'JobID'"
      [filterable]="true"
      [disabled]="disabled"
      (valueChange)="valueChangeJobs($event)"
      search-ex
      [seSearchColumns]="['VpJobId', 'Name']"
      (seFilterChangeEx)="filterDebounce.next($event)"
      [seDebounceFilterChange]="150"
      [seUseCustomLocalFilter]="true"
      [seMinSearchLength]="0"
    >
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <div>
          @if (
            dataItem.JobID &&
            showFavoritesButton &&
            !dataItem.IsTemporaryForemanJob
          ) {
            <span kendoTooltip (click)="toggleFavorite(dataItem, $event)">
              <i
                class="fas fa-star"
                title="Add/Remove Favorite Job"
                [ngStyle]="{
                  color: dataItem.IsUserFavorite ? 'orange' : 'lightgrey',
                }"
              ></i>
              &nbsp;
            </span>
          }
          @if (
            dataItem.JobID &&
            showFacilityTooltip &&
            !dataItem.IsTemporaryForemanJob
          ) {
            <span kendoTooltip [tooltipTemplate]="facilityTooltip">
              <i class="fa fa-info-circle" title></i>
              &nbsp;
            </span>
          }

          <ng-template #facilityTooltip>
            <div>Active Jobs:</div>
            @if (dataItem.FacilityActiveJobs.length === 0) {
              <div>N/A</div>
            }
            @for (job of dataItem.FacilityActiveJobs; track job) {
              <div>{{ job }}</div>
            }
          </ng-template>
          @if (dataItem.JobID) {
            <span class="font-weight-bold">
              {{ dataItem.JobID }}
            </span>
            <span>{{ ' - ' }}</span>
          }
          @if (dataItem.Name) {
            <span class="job-name">{{ dataItem.Name }}</span>
          }
          @if (!dataItem.IsActive && dataItem.JobID) {
            <span class="text-danger">(Closed)</span>
          }
        </div>
      </ng-template>
      <ng-template kendoMultiSelectFooterTemplate>
        @if (resultsCapped()) {
          <div class="job-search-capped">
            Showing the first {{ dropdownTake }} matching jobs. More may match:
            keep typing the job number or name to narrow the list.
          </div>
        }
      </ng-template>
    </kendo-multiselect>
  }

  <div class="d-flex job-search__options">
    @if (showClosedJobsCheckbox) {
      <div>
        <input
          id="closed-jobs-checkbox"
          type="checkbox"
          class="k-checkbox me-2"
          kendoCheckBox
          [formField]="includeClosedJobsForm"
          help-anchor="closed-jobs-checkbox"
        />
        <label for="closed-jobs-checkbox">Include Closed Jobs</label>
      </div>
    }
    @if (showMultiSelectCheckbox) {
      <div>
        <input
          id="multiselect-jobs"
          type="checkbox"
          class="k-checkbox me-2 ms-4"
          kendoCheckBox
          [formField]="isMultiSelectForm"
          help-anchor="multiselect-jobs"
          (change)="onMultiSelectCheckboxChange()"
        />
        <span for="multiselect-jobs">Select multiple jobs</span>
      </div>
    }
  </div>
</div>
